import { AlertCircle, Inbox, Loader2, RefreshCw } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";

export const LoadingBlock = ({ label = "Loading\u2026", rows = 3 }) => (
  <div className="space-y-4" data-testid="loading-skeleton">
    <span className="sr-only" role="status">
      {label}
    </span>
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="rp-surface p-5">
        <Skeleton className="h-4 w-40" />
        <Skeleton className="mt-3 h-10 w-full" />
        <Skeleton className="mt-2 h-3 w-2/3" />
      </div>
    ))}
  </div>
);

export const InlineSpinner = ({ label }) => (
  <span className="inline-flex items-center gap-2 text-sm text-[hsl(var(--muted-foreground))]">
    <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
    {label}
  </span>
);

export const ErrorState = ({ title = "That didn\u2019t work", message, onRetry }) => (
  <Alert variant="destructive" data-testid="error-alert">
    <AlertCircle className="h-4 w-4" />
    <AlertTitle>{title}</AlertTitle>
    <AlertDescription className="space-y-3">
      <p>{message}</p>
      {onRetry ? (
        <Button
          size="sm"
          variant="outline"
          onClick={onRetry}
          data-testid="error-retry-button"
          className="bg-white"
        >
          <RefreshCw className="mr-2 h-3.5 w-3.5" />
          Try again
        </Button>
      ) : null}
    </AlertDescription>
  </Alert>
);

export const EmptyState = ({ icon: Icon = Inbox, title, message, action }) => (
  <div
    className="rp-surface flex flex-col items-start gap-3 p-8 text-left"
    data-testid="empty-state"
  >
    <span className="grid h-10 w-10 place-items-center rounded-lg bg-[hsl(var(--muted))] text-[hsl(var(--rp-navy))]">
      <Icon className="h-5 w-5" aria-hidden="true" />
    </span>
    <h3 className="text-base font-semibold">{title}</h3>
    {message ? (
      <p className="max-w-xl text-sm leading-6 text-[hsl(var(--muted-foreground))]">{message}</p>
    ) : null}
    {action}
  </div>
);
